import { render, staticRenderFns } from "./ModalCallResult.vue?vue&type=template&id=6a1e4ae2"
import script from "./ModalCallResult.vue?vue&type=script&lang=js"
export * from "./ModalCallResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports